import type { AudioAsset } from "@/components/assets/AudioAsset.js";
import type { AssetLoader } from "@/components/assets/AssetLoader.js";
import reactionNotificationMp3 from "@rosette/assets/src/audio/reaction_notification.mp3";
import reactionNotificationWebm from "@rosette/assets/src/audio/reaction_notification.webm";
import errorMp3 from "@rosette/assets/src/audio/error.mp3";
import errorWebm from "@rosette/assets/src/audio/error.webm";


export class ReactionResources {
    private readonly reactionNotification: AudioAsset;
    private readonly error: AudioAsset;

    constructor(assetLoader: AssetLoader) {
        this.reactionNotification = assetLoader.loadAudio(
            [reactionNotificationWebm, reactionNotificationMp3],
        );
        this.error = assetLoader.loadAudio(
            [errorWebm, errorMp3],
        );
    }

    getReactionNotificationSound(): AudioAsset {
        return this.reactionNotification;
    }

    getErrorSound(): AudioAsset {
        return this.error;
    }
}
